import React, {createContext} from 'react';

// Due to new version migration (16 -> 19) changed react.createContext to create context.
const CurrentPracticeContext = createContext();

export class CurrentPracticeProvider extends React.Component {
  state = {
    currentPractice: {},
  };

  componentDidMount() {
    const { value: currentPractice } = this.props;
    this.setCurrentPractice(currentPractice);
  }

  setCurrentPractice = newCurrentPractice => {
    this.setState({ currentPractice: newCurrentPractice });
  };

  render() {
    const { currentPractice } = this.state;
    const { children } = this.props;

    return (
      <CurrentPracticeContext.Provider
        value={{
          id: currentPractice.id,
          currentPractice,
          setCurrentPractice: this.setCurrentPractice,
        }}
      >
        {children}
      </CurrentPracticeContext.Provider>
    );
  }
}

export const CurrentPracticeConsumer = CurrentPracticeContext.Consumer;

export default CurrentPracticeContext;
